import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inner smartgate" }
const _hoisted_2 = { class: "tab_wrap" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "on" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "sub_tit" }, "진출입 게이트", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "진출입 게이트는 주로 하천변 산책로 입구와 등산로 통제 지점 등에 설치하여 이러한 악천우로부터 인명피해를 방지하기 위하여 설치합니다. 또한 도래샘의 진출입 게이트를 설치하면 원격(PC, 핸드폰)에서 여러개의 게이트를 동시에 열고 닫을 수 있습니다. 스마트 원격관제시스템을 도입하여 실시간으로 확인하고 제어하여 효율적으로 재난상황에 대처할 수 있습니다.", -1)
const _hoisted_9 = { class: "box" }
const _hoisted_10 = { class: "gate_list" }
const _hoisted_11 = { class: "img" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "flag" }, "원격 관제", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dl", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("dt", null, [
    /*#__PURE__*/_createTextVNode("스윙식 진출입 게이트 "),
    /*#__PURE__*/_createElementVNode("span", null, "[회전(Swing), z축(yaw)]")
  ]),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createTextVNode("진출입 게이트는 폭우, 태풍 등 악천우로부터 하천 범람, 등산로 고립 및 실족 등을 방지하기 위하여 하천변 산책로와 교량, 등산로에 설치합니다. 또한 원격(pc, 핸드폰)에서 진출입 게이트를 실시간으로 확인하고 제어하여 빠르고 효율적으로 재난상황에 대처할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 활용범위 : 3m 이내 공간 ")
  ])
], -1)
const _hoisted_15 = { class: "img" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "flag" }, "원격 관제", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dl", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("dt", null, [
    /*#__PURE__*/_createTextVNode("차단식 게이트 "),
    /*#__PURE__*/_createElementVNode("span", null, "[회전(Swing), x축(roll)]")
  ]),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createTextVNode("진출입 게이트는 폭우, 태풍 등 악천우로부터 하천 범람, 등산로 고립 및 실족 등을 방지하기 위하여 하천변 산책로와 교량, 등산로에 설치합니다. 또한 원격(pc, 핸드폰)에서 진출입 게이트를 실시간으로 확인하고 제어하여 빠르고 효율적으로 재난상황에 대처할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 활용범위 : 3m 이상 공간 ")
  ])
], -1)
const _hoisted_19 = { class: "img" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "flag" }, "원격 관제", -1)
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dl", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("dt", null, [
    /*#__PURE__*/_createTextVNode("하강식 게이트 "),
    /*#__PURE__*/_createElementVNode("span", null, "[슬라이딩(Sliding), z축]")
  ]),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createTextVNode("진출입 게이트는 폭우, 태풍 등 악천우로부터 하천 범람, 등산로 고립 및 실족 등을 방지하기 위하여 하천변 산책로와 교량, 등산로에 설치합니다. 또한 원격(pc, 핸드폰)에서 진출입 게이트를 실시간으로 확인하고 제어하여 빠르고 효율적으로 재난상황에 대처할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 활용범위 : 터널, 교량 및 6m 이상 공간 ")
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"box system\"><h2 class=\"sub_tit\">보행자 안전 기능</h2><p class=\"list_tit\">공통</p><ul class=\"system_list comm\"><li><dl class=\"desc\"><dt>경광등 (시각적)</dt><dd>안전게이트 작동 시 경광등이 회전하며 깜빡입니다. 주변 보행자 등에게 시각적으로 안전게이트의 작동을 인지하게 하여 주의를 환기시킵니다.</dd></dl></li><li><dl class=\"desc\"><dt>사이렌 (청각적)</dt><dd>안전게이트 작동 시 경광등 작동과 함께 안내 음성이 스피커를 통해 전달됩니다. 주변 보행자에게 청각적으로 안전게이트의 작동을 인지하게 하여 주의를 환기시킵니다. 또한 안내 음성의 내용을 녹음하여 원하는 정보를 전달할 수 있습니다. (하천 범람 주의 안내 등) </dd></dl></li></ul><p class=\"list_tit\">진출입 게이트</p><ul class=\"system_list gate\"><li><dl class=\"desc\"><dt>비상버튼</dt><dd>출입구 안쪽에 설치된 비상버튼으로 진출입 게이트가 닫힌 상태에서 하천 내 고립된 보행자가 게이트를 스스로 열고 나올 수 있는 버튼입니다. 비상 열림 버튼을 누르면 게이트가 열리며 일정 시간(10~15초)이 지난 후 다시 작동하여 닫힙니다. </dd></dl></li><li><dl class=\"desc\"><dt>인체감지 센서</dt><dd>진출입 게이트가 닫혀 있는 상태, 즉 하천 범람 등의 이유로 게이트를 닫아 진출입을 폐쇄한 상태에서 1~2미터 이내 게이트에 다가오는 사람이 있으면 이를 감지하여 사이렌(안내 음성)을 재생합니다. </dd></dl></li><li><dl class=\"desc\"><dt>게이트 작동 중 끼임 방지</dt><dd>진출입 게이트가 닫히는 작동 중에 보행자 또는 물체가 닿으면 닫히는 동작을 멈추고 문이 열립니다. 이후 일정 시간(10~15초)이 지난 후 다시 작동하여 닫힙니다.</dd></dl></li></ul></div>", 1)


const __default__ = {
  name: 'SmartGate_1',
}
import img_gate01 from '@/assets/images/pages/img_gate01.jpg';
import img_gate02 from '@/assets/images/pages/img_gate02.jpg';
import img_gate03 from '@/assets/images/pages/img_gate03.jpg';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/smartGate",
          custom: ""
        }, {
          default: _withCtx(({href, navigate}) => [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                href: href,
                onClick: navigate
              }, "진출입 게이트", 8, _hoisted_5)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/smartGate/2",
          custom: ""
        }, {
          default: _withCtx(({href, navigate}) => [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: href,
                onClick: navigate
              }, "차수판", 8, _hoisted_6)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("img", {
              src: _unref(img_gate01),
              alt: "게이트 이미지"
            }, null, 8, _hoisted_13)
          ]),
          _hoisted_14
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("img", {
              src: _unref(img_gate02),
              alt: "게이트 이미지"
            }, null, 8, _hoisted_17)
          ]),
          _hoisted_18
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("img", {
              src: _unref(img_gate03),
              alt: "게이트 이미지"
            }, null, 8, _hoisted_21)
          ]),
          _hoisted_22
        ])
      ])
    ]),
    _hoisted_23
  ]))
}
}

})